(function () {

  'use strict';

  function pxGroupSettings(
    GroupListService, toastr, $filter, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        group: '=group',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/groupProperties/groupSettings/groupSettings.template.html',
      link: function (scope) {

        scope.securePrintIsEnabled = scope.tenant.info._embedded.productsAndFeatures.features.SECURE_PRINT.enabled;
        scope.printLaterEnabled = scope.tenant.info._embedded.securePrintConfiguration.enablePrintLater;

        scope.secureSetting = {
          mustPrintSecurelyGroup: false,
          printLaterByDefaultGroup: false,
          minimumLevel: 0
        };

        scope.securityLevels = {
          0: 'NONE',
          1: 'QR',
          2: 'NFC',
          3: 'ON_DEVICE_RELEASE'
        };

        (function () {
          checkForGlobalMinimumLevel(scope.group);
        })();

        function checkForGlobalMinimumLevel(group) {
          switch (scope.tenant.info._embedded.securePrintConfiguration.minimumSecurityLevel) {
            case 'NONE':
              scope.hasGlobalMinimumLevel = { level: 0, globalLevel: 0 };
              break;
            case 'QR':
              scope.hasGlobalMinimumLevel = { level: 1, globalLevel: 1 };
              break;
            case 'NFC':
              scope.hasGlobalMinimumLevel = { level: 2, globalLevel: 2 };
              break;
            case 'ON_DEVICE_RELEASE':
              scope.hasGlobalMinimumLevel = { level: 3, globalLevel: 3 };
              break;
          }
          checkGroupSecureSettings(group);
        }

        function checkGroupSecureSettings(group) {

          scope.secureSetting.mustPrintSecurelyGroup =
            scope.tenant.info._embedded.securePrintConfiguration._embedded.mustPrintSecurelyGroup.some(function (securePrintGroup) {
              return securePrintGroup._links.self.href === group.info._links.self.href;
            });

          scope.secureSetting.printLaterByDefaultGroup =
            scope.tenant.info._embedded.securePrintConfiguration._embedded.printLaterByDefaultGroup.some(function (printLaterGroup) {
              return printLaterGroup._links.self.href === group.info._links.self.href;
            });

          const qrFound = scope.tenant.info._embedded.securePrintConfiguration._embedded.securityLevelQR.some(function (qr) {
            return qr._links.self.href === group.info._links.self.href;
          });

          const nfcFound = scope.tenant.info._embedded.securePrintConfiguration._embedded.securityLevelNFC.some(function (nfc) {
            return nfc._links.self.href === group.info._links.self.href;
          });

          const onDeviceReleaseFound = scope.tenant.info._embedded.securePrintConfiguration._embedded.securityLevelON_DEVICE_RELEASE.some(function (onDeviceRelease) {
            return onDeviceRelease._links.self.href === group.info._links.self.href;
          });

          if (onDeviceReleaseFound) {
            scope.secureSetting.minimumLevel = 3;
          } else if (nfcFound) {
            scope.secureSetting.minimumLevel = 2;
          } else if (qrFound) {
            scope.secureSetting.minimumLevel = 1;
          } else {
            scope.secureSetting.minimumLevel = 0;
          }

          if (scope.hasGlobalMinimumLevel.level < scope.secureSetting.minimumLevel) {
            scope.hasGlobalMinimumLevel.level = scope.secureSetting.minimumLevel;
          }

        }

        function addSecurityLevelToGroup(securityLevel) {
          scope.working = true;
          const url = scope.tenant.info._embedded.securePrintConfiguration._links['px:securityLevelGroupsUpdateRequests'].href
            .replace('{securityLevel}', scope.securityLevels[securityLevel]);
          const postObject = [{
            type: 'ADD',
            securityLevel: scope.securityLevels[securityLevel],
            groups: [scope.group.info._links.self.href]
          }];
          GroupListService.addSecuritySettingOnGroups(url, postObject)
            .then(function () {
              toastr.success($filter('translate')('ChangesSaved'));
              refreshSecurePrintConfiguration();
            })
            .catch(function () {
              toastr.error($filter('translate')('ERROR'));
              refreshSecurePrintConfiguration();
            })
            .finally(function () {
              // Will be set to false in refreshSecurePrintConfiguration().
              // scope.working = false;
            });
        }

        function refreshSecurePrintConfiguration() {
          scope.working = true;
          const url = scope.tenant.info._embedded.securePrintConfiguration._links.self.href;
          $http.get(url)
            .then(function (response) {
              scope.tenant.info._embedded.securePrintConfiguration = response.data;
              checkForGlobalMinimumLevel(scope.group);
            })
            .catch(function () {
              checkForGlobalMinimumLevel(scope.group);
            })
            .finally(function () {
              scope.working = false;
            });
        }

        scope.saveChangesSecuritySettings = function (securityLevel) {
          scope.working = true;
          const url = scope.tenant.info._embedded.securePrintConfiguration._links['px:securityLevelGroupsUpdateRequests'].href
            .replace('{securityLevel}', scope.securityLevels[scope.secureSetting.minimumLevel]);
          const postObject = [{
            type: 'DELETE',
            groups: [scope.group.info._links.self.href]
          }];
          GroupListService.addSecuritySettingOnGroups(url, postObject)
            .then(function () {
              if (securityLevel > 0) {
                addSecurityLevelToGroup(securityLevel);
              } else {
                toastr.success($filter('translate')('ChangesSaved'));
                refreshSecurePrintConfiguration();
              }
            })
            .catch(function () {
              toastr.error($filter('translate')('ERROR'));
              refreshSecurePrintConfiguration();
            })
            .finally(function () {
              // Will be set to false in refreshSecurePrintConfiguration().
              // scope.working = false;
            });
        };

        scope.changePrintLater = function () {
          scope.working = true;
          const url = scope.tenant.info._embedded.securePrintConfiguration._links['px:printLaterByDefaultGroupsUpdateRequests'].href;
          const postObject = [{
            type: scope.secureSetting.printLaterByDefaultGroup ? 'ADD' : 'DELETE',
            groups: [scope.group.info._links.self.href]
          }];
          GroupListService.addSecuritySettingOnGroups(url, postObject)
            .then(function (response) {
              toastr.success($filter('translate')('ChangesSaved'));
              refreshSecurePrintConfiguration();
            })
            .catch(function () {
              toastr.error($filter('translate')('ERROR'));
              refreshSecurePrintConfiguration();
            })
            .finally(function () {
              // Will be set to false in refreshSecurePrintConfiguration().
              // scope.working = false;
            });
        };

        scope.changePrintSecurely = function () {
          scope.working = true;
          const url = scope.tenant.info._embedded.securePrintConfiguration._links['px:mustPrintSecurelyGroupsUpdateRequests'].href;
          const postObject = [{
            type: scope.secureSetting.mustPrintSecurelyGroup ? 'ADD' : 'DELETE',
            groups: [scope.group.info._links.self.href]
          }];
          GroupListService.addSecuritySettingOnGroups(url, postObject)
            .then(function (response) {
              toastr.success($filter('translate')('ChangesSaved'));
              refreshSecurePrintConfiguration();
            })
            .catch(function () {
              toastr.error($filter('translate')('ERROR'));
              refreshSecurePrintConfiguration();
            })
            .finally(function () {
              // Will be set to false in refreshSecurePrintConfiguration().
              // scope.working = false;
            });
        };

      }
    };
  }

  pxGroupSettings.$inject = ['GroupListService', 'toastr', '$filter', '$http'];

  angular
    .module('printix-admin')
    .directive('pxGroupSettings', pxGroupSettings);

})();
